var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotSaveError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4743_40190)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 7,
    width: 11.3137,
    height: 11.3137,
    rx: 3,
    transform: "rotate(-45 -1 7)",
    fill: "#FFD059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63273 8.88432C6.73677 8.81862 6.85909 8.78355 6.98421 8.78355C7.152 8.78355 7.31292 8.84655 7.43157 8.95868C7.55021 9.07082 7.61687 9.22291 7.61687 9.38149C7.61687 9.49976 7.57976 9.61536 7.51025 9.71369C7.44073 9.81203 7.34192 9.88866 7.22632 9.93392C7.11072 9.97918 6.98351 9.99102 6.86079 9.96795C6.73807 9.94488 6.62534 9.88793 6.53686 9.80431C6.44838 9.72068 6.38813 9.61414 6.36372 9.49815C6.33931 9.38216 6.35184 9.26193 6.39972 9.15267C6.4476 9.04341 6.52869 8.95002 6.63273 8.88432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53686 4.17513C6.65551 4.063 6.81643 4 6.98421 4C7.152 4 7.31292 4.063 7.43157 4.17513C7.55021 4.28727 7.61687 4.43936 7.61687 4.59794V6.98972C7.61687 7.1483 7.55021 7.30039 7.43157 7.41253C7.31292 7.52467 7.152 7.58766 6.98421 7.58766C6.81643 7.58766 6.65551 7.52467 6.53686 7.41253C6.41822 7.30039 6.35156 7.1483 6.35156 6.98972V4.59794C6.35156 4.43936 6.41822 4.28727 6.53686 4.17513Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4743_40190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotSaveError);
export default __webpack_public_path__ + "static/media/bot-save-error.91c65332d388db3769b1b8f51a935aa8.svg";
export { ForwardRef as ReactComponent };